import React from 'react'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
class Loader1 extends React.Component{
    render()
    {
        return (

            <Loader type="ThreeDots"  color="#000"
            height={200}
            width={200} ></Loader>
        )
    }
}
export default Loader1